import { PageButtonSchema } from '@/views/sports/components/PageButton/styles/PageButton.styles';

export const pageButtonStyles: PageButtonSchema = {
  button: {
    variant: 'unstyled',
    fontSize: '2xs',
    textShadow: 'none',
    color: 'white',
    h: 'fit-content',
    textTransform: 'uppercase',
    sx: {
      '&&': {
        fontWeight: 'bold',
      },
      svg: {
        bg: 'beta.400',
        p: '0.5',
        color: '#24194f',
        borderRadius: 'sm',
      },
    },
    _hover: {
      color: 'gamma.500',
    },
  },
};
